exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-list-view{width:100%;background:#fff}.search-list-view .text-center{text-align:center}.search-list-view .property-item{opacity:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.search-list-view .property-item .availability{text-align:left}.search-list-view .property-item .property-body{margin-bottom:15px;line-height:24px;min-height:120px}.search-list-view .property-item .col-1{background:#f3f3f3;width:270px}.search-list-view .property-item .col-1 img{vertical-align:top}.search-list-view .property-item .col-2{width:calc(100% - 300px)}", ""]);

// exports
